/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { StandaloneFollowAuthor as ResolvedStandaloneFollowAuthor } from 'base/components/standalone/FollowAuthor';

export const FollowAuthor: typeof ResolvedStandaloneFollowAuthor = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneFollowAuthor {...props} />
    );
});

export type FollowAuthorProps = PropsFromComponent<typeof FollowAuthor>;

/** @deprecated Use slot architecture instead */
export const FollowAuthorWith = (extras: DynamicStandaloneExtras): typeof FollowAuthor => {
    return function FollowAuthor(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'FollowAuthor');
        return <ResolvedStandaloneFollowAuthor {...mergeProps({ options: { theme } }, props)} />;
    }
}